"use strict";

define('app/reporting/edit/audit.report.edit.controller',['app/reporting/edit/audit.report.edit.view', 'rs/abstract.content.controller', 'rs/models/report', 'rs/services/report.service', 'e3-modal', 'e3-table'], function (AuditReportEditView, AbstractContentController, ReportModel, ReportService, E3Modal, E3Table) {
  var AuditReportEditController = AbstractContentController.extend({
    contentName: 'audit-report-edit-content abstract-content fixed-header off-white',
    properties: ['report', 'reportColumns', 'reportService', 'reportPreviewTable', 'availableColumns'],
    initialize: function initialize() {
      this._super.apply(this, arguments);
      this.setReportService(new ReportService());
      this.getReportService().configure({
        reportTypeName: 'IRB_Audit'
      });
    },
    addReportColumn: function addReportColumn(column) {
      var availableColumns = this.getAvailableColumns(),
        index = availableColumns.indexOf(column);
      if (index > -1) {
        availableColumns.splice(index, 1);
      }
    },
    removeReportColumn: function removeReportColumn(column) {
      var availableColumns = this.getAvailableColumns(),
        index = availableColumns.indexOf(column);
      if (index == -1) {
        availableColumns.push(column);
        this.setAvailableColumns(availableColumns);
      }
    },
    cancelReportEdit: function cancelReportEdit() {
      this.getAppController().navigateReportList({
        trigger: true
      });
    },
    deleteCurrentReportDefinition: function deleteCurrentReportDefinition() {
      var report = this.getReport();
      this.getReportService().deleteReportDefinition(report).bind(this).then(function () {
        this.getAppController().navigateReportList({
          trigger: true
        });
      });
    },
    getReportTableOptions: function getReportTableOptions() {
      return {
        columns: [],
        delegate: this,
        selectable: false,
        theme: 'rs'
      };
    },
    getTemplateProperties: function getTemplateProperties() {
      return {
        report: this.getReport(),
        modifyPermission: this.isAbleToModifyReport()
      };
    },
    hasVolatileData: function hasVolatileData() {
      return this.isEdited();
    },
    isAbleToModifyReport: function isAbleToModifyReport() {
      return this.checkPermission('MODIFY_REPORT');
    },
    getPreviewColumns: function getPreviewColumns() {
      var columns = this.getSelectedColumns(),
        numOfColumns = columns.length,
        calculatedWidth = this.getView().getPreviewColumnWidth(numOfColumns);
      if (!numOfColumns) {
        return [{
          name: ''
        }];
      }
      return _.map(columns, function (c) {
        return {
          displayName: c.displayName,
          name: c.name,
          type: 'String',
          width: calculatedWidth
        };
      });
    },
    getReportDefinition: function getReportDefinition() {
      var data = this.getView().getFieldValues();
      return new ReportModel(data);
    },
    getReportPreviewDefinition: function getReportPreviewDefinition() {
      var definition = this.getReportDefinition();
      definition.data.columns = this.getReportColumns();
      return definition;
    },
    getSelectedColumns: function getSelectedColumns() {
      return this.getView().getSelectedColumns();
    },
    refreshReportPreview: function refreshReportPreview() {
      var table = this.getReportPreviewTable(),
        newColumns = this.getPreviewColumns(),
        that = this;
      table.setColumns(newColumns);
      _.defer(function () {
        that.getView().resizePreviewTable();
      });
    },
    requestCreateReportDefinition: function requestCreateReportDefinition(data) {
      return this.getReportService().createReportDefinition(data).bind(this).then(function (report) {
        this.clearEditFlag();
        this.getAppController().navigateReportList({
          trigger: true
        });
      });
    },
    requestCreateRunReportDefinition: function requestCreateRunReportDefinition(data) {
      return this.getReportService().createReportDefinition(data).bind(this).then(function (report) {
        this.clearEditFlag();
        this.getReportService().runReportDefinition(report);
        this.getAppController().navigateReportList({
          trigger: true
        });
      });
    },
    requestPageSave: function requestPageSave() {
      var data = this.getView().getFieldValues(),
        report = this.getReport();
      report.applyProperties(data);
      return this.getReportService().saveReportDefinition(report).bind(this).tap(function () {
        this.clearEditFlag();
      });
    },
    requestSaveReportDefinition: function requestSaveReportDefinition(data) {
      var report = this.getReport();
      report.applyProperties(data);
      return this.getReportService().saveReportDefinition(report).bind(this).then(function () {
        this.clearEditFlag();
        this.getView().refresh();
      });
    },
    requestSaveRunReportDefinition: function requestSaveRunReportDefinition(data) {
      return this.requestSaveReportDefinition(data).bind(this).then(function () {
        var report = this.getReport();
        this.getReportService().runReportDefinition(report);
        this.clearEditFlag();
      });
    },
    refreshReportDefinition: function refreshReportDefinition() {
      this.refreshAvailableColumns();
      this.getView().refresh();
    },
    isEdited: function isEdited() {
      return !!this._editing;
    },
    clearEditFlag: function clearEditFlag() {
      this._editing = false;
    },
    setEditFlag: function setEditFlag() {
      this._editing = true;
    },
    setupView: function setupView() {
      this.setView(new AuditReportEditView());
    },
    start: function start(reportDefinitionId) {
      return this.getReportService().load('type').bind(this).then(function () {
        return this.getReportService().requestColumns();
      }).then(function (columns) {
        this.setReportColumns(columns || []);
        this.setReportPreviewTable(new E3Table.AccordionController(this.getReportTableOptions()));
        if (reportDefinitionId) {
          return this.getReportService().requestReportDefinition(reportDefinitionId).bind(this).then(function (report) {
            this.setReport(report);
            this.refreshAvailableColumns();
          });
        } else {
          this.refreshAvailableColumns();
        }
      }).then(function () {
        this.getView().render();
      });
    },
    refreshAvailableColumns: function refreshAvailableColumns() {
      var availableColumns = this.getReportColumns(),
        report = this.getReport(),
        selectedColumns = report ? report.data.columns : [];
      if (selectedColumns.length) {
        availableColumns = _.filter(availableColumns, function (column) {
          return !_.findWhere(selectedColumns, {
            name: column.name
          });
        });
      }
      this.setAvailableColumns(availableColumns);
    },
    viewIsAvailable: function viewIsAvailable() {
      var previewTable = this.getReportPreviewTable(),
        view = this.getView();
      this._super.apply(this, arguments);
      previewTable.setup(view.getReportPreviewContainer());
      previewTable.setColumns(this.getPreviewColumns());
      previewTable.start();
      view.resizePreviewTable();
    },
    getData: function getData() {
      var definition = this.getReportPreviewDefinition();
      return this.getReportService().requestDefinitionResults(definition).then(function (data) {
        return data.slice(0, 5);
      });
    },
    isTableItemSelectable: function isTableItemSelectable() {
      return false;
    }
  }, {
    requiredFeature: 'reporting',
    requiredPermissions: ['RUN_REPORT']
  });
  return AuditReportEditController;
});

